import { useQuery } from "@tanstack/react-query";
import { useProductionService } from "../services/production";

export function useProductionPeople(days: number = 14) {
  const service = useProductionService();
  return useQuery({
    queryKey: ["production-people", days],
    queryFn: () => service.getPeopleActivity(days),
    staleTime: 5 * 60_000,
    refetchInterval: 10 * 60_000,
  });
}
